/**
 * @generated SignedSource<<6cd9adc756711b95c42091d989a5ee5d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BrandLoginInput = {
  clientMutationId?: string | null | undefined;
  email: string;
  next?: string | null | undefined;
};
export type LoginMutation$variables = {
  input: BrandLoginInput;
};
export type LoginMutation$data = {
  readonly brandLogin: {
    readonly ok: boolean;
  } | null | undefined;
};
export type LoginMutation = {
  response: LoginMutation$data;
  variables: LoginMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BrandLoginPayload",
    "kind": "LinkedField",
    "name": "brandLogin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LoginMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LoginMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1f561e76fb862978f336c44aff09b338",
    "id": null,
    "metadata": {},
    "name": "LoginMutation",
    "operationKind": "mutation",
    "text": "mutation LoginMutation(\n  $input: BrandLoginInput!\n) {\n  brandLogin(input: $input) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "22ad5ce562168a66438a377b59201e8a";

export default node;
